<template>
  <div class="test" :style="'padding-top:'+barHeight+'px'">
		<van-nav-bar
      :title="title"
      left-arrow
      class="main-nav"
      @click-left="onClickLeft"
    />
		<div id="iframe-container">
			<iframe :src="iframeSrc" frameborder="0" width="100%" height="100%" scrolling="auto" style="position:relative" ref="iframe" id="iframe"></iframe>
  	</div>
    <modal
      ref="modalGrow"
      btnType='2'
      :showImg='false'
      :cancelText='cancelText'
      :sureText='sureText'
      :showClsoeBtn='true'
      :closeFnValue='true'
      @submit="sure"
      @cancel="cancel"
    >
      <template v-slot:body>
        <div class="tip">
          <p>{{ test }}</p>
        </div>
      </template>
    </modal>
    <!-- 报告查看提醒   -->
    <modal
      ref="modalReport"
      btnType='2'
      :showImg='false'
      cancelText='返回'
      sureText='去查看'
      :showClsoeBtn='true'
      :closeFnValue='true'
      @submit="handleGoReports"
      @cancel="handleCancel"
    >
      <template v-slot:body>
        <div class="tip">
          <p>稍后您可在家长测试页面右上角'成长记录'中查看您的专属测评报告</p>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import {verticalScreen} from '../../assets/js/vertical-screen';
import { _projectProgress } from '../../api/test-center';
import Modal from "../../components/common/modal.vue";
import { decryptBy , encryptBy } from '@/assets/js/encryption';
import PresentChildren from "../../components/present-children/index";
import { cartoonKidEventStore } from "../../common/cartoon-kid-event-store";
export default {
  components: { Modal },
  name: 'test',
  data() {
    return {
      title: "",// 量表名称
			iframeSrc:'', // 量表地址
      iframeHeight:null,// 页面高度
      sureText:'我要答完',//确定按钮名称
      cancelText:'狠心离开',//取消按钮名称
      modalType:1,//弹框类型
      test:'您已经回答很多了，还有一点就填完了，确定退出吗？',//弹窗文案
      backType:1,//返回方式
      barHeight:null,
      type:false,
      next:'',
    };
  },
  created() {
    this.title = this.$route.query.title;
    this.iframeSrc = this.$route.query.projectUrl;
    let num = Math.round(Math.random()*10)
    let name;
    if(this.$route.query.type === '3') {
      name = '家长'
    }else {
      name = '儿童'
    }
    if (num>5) {
      this.test = '您已经回答很多了，还有一点就填完了，确定退出吗？';
    }else {
      this.test = '大多数' + name + '都填写完成了，您确定退出吗？';
    };
    cartoonKidEventStore.setJumpAction((next) => {
      this.next = next;
      this.projectProgress();
      this.backType = 2;
    });
  },
  mounted() {
    verticalScreen();
    // 适配页面高度
    // let appHeight = document.documentElement.clientHeight;
    // this.barHeight = document.getElementsByClassName("main-nav")[0].clientHeight;
    // this.iframeHeight = Number(appHeight) - Number(this.barHeight) + 'px';
  },
  methods: {
    onClickLeft() {
      this.backType = 1;
      this.projectProgress();
    },
    sure() {
      this.$refs.modalGrow.closeDialog();
    },
    cancel(type) {
      if (type === 1) {
        if (this.backType === 2){
          this.next();
        }else {
          this.$router.go(-1);
          this.$refs.modalGrow.closeDialog();
        }
      }else {
        this.$refs.modalGrow.closeDialog();
      }
    },
  getQueryString(urlObj,name) {
        const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r =urlObj.indexOf('#')>-1? urlObj.split("?")[1].match(reg) : urlObj.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    },
    // 查询家长儿童每个分类正在进行中的问卷数量
    projectProgress() {
      let childId;
      let parentId;
      let params;
      let id=this.getQueryString(this.$route.query.projectUrl,'id')
      if (this.$route.query.type === '2'){
        params = {
          childId:localStorage.getItem("childId"),
          questionnaireId: id,
        }
      }else {
        params = {
          parentId: JSON.parse(decryptBy(localStorage.getItem("userInfo"))).userId,
          questionnaireId: id,
        }
      }
      _projectProgress(params).then((res) => {
        if (res && res.code == 200) {
          if (res.data.resultId) {
            this.$refs.modalGrow.openDialog();
            this.type = true
          }else {
            if (this.backType == 1){
              // 离开页面弹出报告查看
              // if (this.$route.query.type == '3') {
              //   // this.$refs.modalReport.openDialog();
              // } else {
              //   this.$router.go(-1);
              // }
              this.$router.go(-1);
            }else {
              this.next();
            }
            this.type = false
          }
        } else {
          this.$toast(res.msg);
        }
      });
    },
    handleGoReports() {
      this.$router.push({
        path: "/growClub?type=1",
      });
    },
    handleCancel() {
      this.$refs.modalReport.closeDialog();
      this.backType = 1;
      this.$router.go(-1);
    }
  },
};
</script>
<style lang="scss" scoped>
.test{
	width: 100%;
	padding-top: 50px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
	.main-nav{
		position: fixed;
		width: 100%;
		top: 0;
	}
  #iframe-container{
    flex: 1;
  }
}
.tip{
  text-align: center;
}

::v-deep .van-icon {
  color: #000;
}
</style>
